export function localisedSdgList(): SDG[] {
  return [
    'KEINE_ARMUT',
    'KEIN_HUNGER',
    'GESUNDHEIT_UND_WOHLERGEHEN',
    'HOCHWERTIGE_BILDUNG',
    'GESCHLECHTER_GLEICHHEIT',
    'SAUBERES_WASSER_UND_SANITAEREINRICHTUNGEN',
    'BEZAHLBARE_UND_SAUBERE_ENERGIE',
    'MENSCHENWUERDIGE_ARBEIT_UND_WIRTSCHAFTSWACHSTUM',
    'INDUSTRIE_INNOVATION_UND_INFRASTRUKTUR',
    'WENIGER_UNGLEICHHEITEN',
    'NACHHALTIGE_STAEDTE_UND_GEMEINDEN',
    'NACHHALTIGE_R_KONSUM_UND_PRODUKTION',
    'MASSNAHMEN_ZUM_KLIMASCHUTZ',
    'LEBEN_UNTER_WASSER',
    'LEBEN_AN_LAND',
    'FRIEDEN_GERECHTIGKEIT_UND_STARKE_INSTITUTIONEN',
    'PARTNERSCHAFTEN_ZUR_ERREICHUNG_DER_ZIELE',
  ]
}

export type SDG = string
